import React from "react";
import colors from '../../theme/variables/colors';
import { getEnvVar } from '../../config/RuntimeConfig';

interface Props {
    isEng: boolean;
    HasLoginBanner?: boolean;
    wording?: string;
    wordingFRA?: string;
}

const LoginBannerComponent = ({isEng, HasLoginBanner, wording, wordingFRA} : Props) => {
    if (!HasLoginBanner) {
        return null;
    }

    const defaultText = {
        eng: " for easier and faster process",
        fra: " pour un processus plus facile et plus rapide",
    };

    const customText = isEng ? wording : wordingFRA;
    const bannerText = customText
        ? customText
        : (isEng ? defaultText.eng : defaultText.fra);

    return (
        <div className="ontario-padding-top-16-! ontario-padding-bottom-16-!"
        style={{
            borderBottom: `.0625rem solid ${colors.palette.greyscale40}`,
            backgroundColor: colors.palette.systemInformationBlue,
        }}>
                <div className="ontario-row">
                <div className="ontario-column ontario-small-12">
                    <div className="ontario-alert__header-icon" style={{flexShrink: 0}}>
                        <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-information"></use>
                        </svg>
                    </div>
                    <>
                        <a href={!!isEng ? getEnvVar('CXP_URL') : getEnvVar('CXP_URL_F')}>
                            { isEng ? "Create a ServiceOntario Account or log in" : "Créez un Compte ServiceOntario ou connectez-vous" }
                        </a>
                        {bannerText}
                    </>
                </div>
            </div>
        </div>
    );   
}

export default LoginBannerComponent;